import ScrollableBox, { IScrollableBoxProps } from '../ScrollableBox';
import PanelContent, { IPanelContentProps } from '../../../Panel/components/PanelContent';

export interface IScrollablePanelContentProps extends IPanelContentProps {
  scrollableBoxProps?: IScrollableBoxProps;
}

const ScrollablePanelContent = (props: IScrollablePanelContentProps) => {
  const { scrollableBoxProps, ...restProps } = props;
  return (
    <ScrollableBox {...scrollableBoxProps}>
      <PanelContent {...restProps} />
    </ScrollableBox>
  );
};

export default ScrollablePanelContent;
